import type { BrandedHeadingModule } from 'types/capi/article';

type Props = {
  module: BrandedHeadingModule;
};

export function BrandedHeadingCore({ module }: Props) {
  const theme = module.theme.light;

  return (
    <>
      <div
        className="inline-flex h-8 w-fit items-center border px-2 max-md:h-7"
        style={{
          backgroundColor: theme.background,
          borderColor: theme.border,
          color: theme.foreground
        }}
      >
        <span className="text-overline">{module.highlight_text}</span>
      </div>
      <h2 className="text-title-lg">{module.heading_text}</h2>
    </>
  );
}

export default function BrandedHeading({ module }: Props) {
  return (
    <div className="flex w-full items-center justify-center px-4 md:px-10">
      <div className="flex w-full max-w-desktop flex-col gap-3 max-md:gap-2.5">
        <BrandedHeadingCore module={module} />
      </div>
    </div>
  );
}
